import { combineReducers, ThunkDispatch, AnyAction } from "@reduxjs/toolkit";
import { itemsHaveError, itemsAreLoading, bcfData } from "@Features/issues/state/bcfData";
import toastNotificationContent from "./toastSlice";
import issues from "@Features/issues/state/issues";
import zoomLevel from "./zoomSlice";
import {
  filesSharedUnderResources,
  setFilesData,
  setFileDependencies,
  dependencyQuerySettings,
  currentFileVersionId,
  fileRecordRefusals,
  fileRecordsUnavailable,
} from "./fileVersion";
import { refreshFileManager, selectedFiles, currentFolder, fileManagerBreadCrumb } from "./refreshFileManager";
import { projectData, spaceData, allSpacesInProject, breadCrumbData } from "./breadcrumbsdata";
import { issuesStatuses } from "@Features/issues/state/issuesStatuses";
import { save_space_List } from "./dashboard";
import { deleteIssueData } from "@Features/issues/state/deleteIssues";
import { editIssues } from "@Features/issues/state/editIssues";
import { currentPath } from "./filesStatuses";
import { estimateStatuses } from "./estimateStatuses";
import { projectsStatuses } from "./projectsStatuses";
import {
  saveTransmital,
  saveTransmitalMetadata,
  setTransmittalAccessReducer,
  setTransmittalVersionsReducer,
  setTransmittalDataForReviewsReducer,
  setTransmittalReferencesReducer,
} from "@Features/transmittals/state/transmitals.reducer";
import userDetails from "./userDetailsSlice";
import checkIfAuthenticated from "./authentication";
import signinData from "./signinData";
import { userPermissions, portalSettingInfo, portalSettingInfoRead } from "./userPermissions";
import {
  roleData,
  spacesUsersData,
  setEntityList,
  deleteSpace,
  DeletedUserState,
  getProjectSettingObject,
  projectSideBarIconAndNameMapperReducer,
} from "./projectSetting";
import { projectUsers, spaceUsers, UserInProject } from "./projectUsers";
import {
  TaskDetails,
  GanttDetails,
  scheduleError,
  sliderTimer,
  selectionSetTaskElements,
  simulationMetrics,
} from "./Tasks";
import { resourceCreated } from "./Resources";
import { contractDetails } from "@Features/contracts/state/contracts.reducer";
import { currencyDetails } from "./currency";
import { clashDetails } from "./clash";
import { isFileAnOlderVersion } from "./designViewer";
import {
  fileUploadList,
  fileUploadState,
  isFileVersionUploading,
  fileUploadProperties,
  currentFileUploadProperties,
} from "./minimiseFileUpload";
import {
  UserInPortal,
  currentUserPermissions,
  statusPortalData,
  portalEntityList,
  getCostDatabaseData,
  getSymbolsData,
  profileData,
  getPortalSetting,
  portalData,
  customModules,
  UserCountInPortal,
  renderHeader,
} from "./portalSetting";
import { notificationsData, notificationsStatus, unreadNotificationsCount, showNotification } from "./notification";
import { showPortalChat, portalChatUnreadCount } from "./portalChat";
import { showCubeAi } from "./cubeAi";
import {
  HoopsModalStatus,
  GetSettingModalData,
  transparentElements,
  getSelectedNestedMeasurements,
  measurementAttributePopup,
  isBottomToolbarRefreshRequired,
  viewerState,
  isSheetActive,
  faceSelection,
  socketDisconnected,
  modelProperties,
  viewReducer,
  modifiedModelProps,
  scsFileLoadProgress,
} from "./Viewer";
import { portalUnits } from "./portalUnits";
import { spaceUserDataForFolder, getAccessPermission, getSpaceToggle } from "./AccessPermissionReducer";
import { licenceStatus, privacyPolicyStatus } from "./licence";
import { organisationDetails } from "./organisationDetails";
import { issueCount } from "@Features/issues/state/issuesCount";
import { getSpaceRoles } from "./spaceSetting";
import {
  estimateList,
  getEstimateAdditionalCost,
  getDateVersion,
  estimateData,
  additionalCostTotal,
  estimateFieldsNeedToRefresh,
  estimateErrorReducer,
} from "./EstimateList";
import { costDatabase } from "./CostDatabaseReducer";
import {
  measurementsList,
  takeoffsList,
  takeoffData,
  measurementsModalStatus,
  isMeasurementStarted,
} from "./measurements";
import { selectedSet, selectionSetUpdated } from "./selections";
import layout, { layoutStatus } from "./layout";
import { minimizeFloatterData } from "./minimizerFloatter";
import { portalDashboardData, portalDashboardObject, helpSectionState, onReduceHeader } from "./portalDashboard";
import { projectDashboardData } from "./projectDashboard";
import issuesPinDataReducer from "@Features/issues/state/issuesPinDataSlice";
import { extraIssue } from "@Features/issues/state/extraIssue";
import { commonObjectData, fileversionIdAndNodeOffsetIdMap } from "./common";
import { projectAttachedPosition } from "./orgStructure";
import { reviewFlowData, reviewFlowResourceType, reviewData } from "./ReviewFlows";
import { Databank } from "./Databank";
import { currentSelectedSidebarCell, showStickySidebar, selectedProjectLayout } from "./stickySidebar";
import browserPopupReducer from "./browserPopupSlice";
import userTagData from "./userTagData";
import userProfileModal from "./userProfileModal";
import { fileSyncState, fileSyncMapperState } from "./fileSync";
import { formValidatorStore } from "./Forms";
import preferredLanguage from "./preferredLanguage";
import { overlays } from "./overlays";
import { sidePanel } from "./sidePanel";

const rootReducer = combineReducers({
  userTagData,
  userProfileModal,
  getSymbolsData,
  itemsHaveError,
  itemsAreLoading,
  bcfData,
  issues,
  refreshFileManager,
  projectData,
  spaceData,
  editIssues,
  issuesStatuses,
  save_space_List,
  deleteIssueData,
  selectedFiles,
  currentFolder,
  projectsStatuses,
  transmittals: saveTransmital,
  transmittalMetadata: saveTransmitalMetadata,
  transmittalVersions: setTransmittalVersionsReducer,
  transmittalAccess: setTransmittalAccessReducer,
  transmittalDataForReviews: setTransmittalDataForReviewsReducer,
  transmittalReferences: setTransmittalReferencesReducer,
  userDetails,
  checkIfAuthenticated,
  signinData,
  projectUsers,
  spaceUsers,
  roleData,
  spacesUsersData,
  spaceUserDataForFolder,
  TaskDetails,
  GanttDetails,
  scheduleError,
  clashDetails,
  sliderTimer,
  selectionSetTaskElements,
  setEntityList,
  fileManagerBreadCrumb,
  filesSharedUnderResources,
  filesData: setFilesData,
  fileRecordRefusals,
  fileRecordsUnavailable,
  currentFileVersionId,
  UserInProject,
  allSpacesInProject,
  toastNotificationContent,
  UserInPortal,
  notificationsData,
  notificationsStatus,
  deleteSpace,
  DeletedUserState,
  currentUserPermissions,
  statusPortalData,
  portalEntityList,
  fileDependencies: setFileDependencies,
  dependencyQuerySettings,
  HoopsModalStatus,
  licenceStatus,
  privacyPolicyStatus,
  userPermissions,
  unreadNotificationsCount,
  showNotification,
  showPortalChat,
  portalChatUnreadCount,
  showCubeAi,
  organisationDetails,
  GetSettingModalData,
  issueCount,
  getSpaceRoles,
  estimateList,
  estimateError: estimateErrorReducer,
  getCostDatabaseData,
  measurementsList,
  takeoffsList,
  takeoffData,
  measurementsModalStatus,
  isMeasurementStarted,
  getEstimateAdditionalCost,
  layout,
  layoutStatus,
  getAccessPermission,
  getSpaceToggle,
  zoomLevel,
  profileData,
  getPortalSetting,
  portalSettingInfo,
  portalSettingInfoRead,
  getSelectedNestedMeasurements,
  measurementAttributePopup,
  getProjectSettingObject,
  selectedSet,
  minimizeFloatterData,
  UserCountInPortal,
  portalDashboardData,
  portalDashboardObject,
  issuesPinData: issuesPinDataReducer,
  extraIssue,
  commonObjectData,
  portalData,
  getDateVersion,
  estimateStatuses,
  projectDashboardData,
  transparentElements,
  costDatabase,
  projectAttachedPosition,
  isBottomToolbarRefreshRequired,
  isSheetActive,
  faceSelection,
  socketDisconnected,
  fileversionIdAndNodeOffsetIdMap,
  estimateData,
  viewerState,
  reviewFlowData,
  isFileAnOlderVersion,
  additionalCostTotal,
  estimateFieldsNeedToRefresh,
  Databank,
  breadCrumbData,
  reviewFlowResourceType,
  reviewData,
  fileSyncState,
  fileUploadList,
  fileUploadState,
  fileUploadProperties,
  currentFileUploadProperties,
  contractDetails,
  currencyDetails,
  isFileVersionUploading,
  currentSelectedSidebarCell,
  showStickySidebar,
  selectedProjectLayout,
  currentPath,
  browserPopup: browserPopupReducer,
  resourceCreated,
  modelProperties,
  portalUnits,
  defaultView: viewReducer,
  customModules,
  simulationMetrics,
  formValidatorStore,
  selectionSetUpdated,
  preferredLanguage,
  helpSectionState,
  onReduceHeader,
  fileSyncMapperState,
  renderHeader,
  projectSideBarIconsAndNameMapper: projectSideBarIconAndNameMapperReducer,
  modifiedModelProps,
  scsFileLoadProgress,
  overlays,
  sidePanel,
});
export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;
